export const getCombinedStatus = (row) => {
  // 🔴 Highest priority
  if (row.status === "cancelled") return "cancelled";

  if (row.status === "confirmed") return "confirmed";

  if (row.paymentStatus !== "not_applicable") {
    if (row.paymentStatus === "paid") return "paid";
  }

  if (row.status === "approved") return "approved";

  return "pending";
};